import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

// routes
import home from '@/router/routes/home.js';
import introduction from '@/router/routes/introduction.js';
import personal from '@/router/routes/personal.js';
import exam from '@/router/routes/exam.js';
import tournament from '@/router/routes/tournament.js';
import RouterViewIndex from '@/views/RouterViewIndex.vue';
import i18n from '@/i18n/index.js';

Vue.use(VueRouter);

// 解決重複點擊路由時會報錯
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: RouterViewIndex,
    redirect: {name: 'home-page'},
    meta: {
      title: i18n.t('首頁'),
    },
    children: [...home, ...introduction, ...personal, ...exam, ...tournament],
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/Auth/Signup.vue'),
    meta: {
      title: i18n.t('註冊'),
    },
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import('../views/Auth/TermsOfService.vue'),
    meta: {
      title: i18n.t('服務條款和隱私政策'),
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => import('../views/Auth/ForgetPassword.vue'),
    meta: {
      title: i18n.t('忘記密碼'),
    },
  },
  {
    path: '/exam-notice',
    name: 'exam-notice',
    component: () => import('../views/Exam/ExamNotice.vue'),
    meta: {
      title: i18n.t('檢定須知'),
    },
  },
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/chart',
    name: 'chart',
    component: () => import('../components/Personal/ReportLineChart.vue'),
  },
];

const router = new VueRouter({
  routes,
});

router.afterEach((to) => {
  const user = store.state.auth.userData;

  const requireAuth = to.matched.some((item) => item.meta.requireAuth);
  if (requireAuth && user?.id == null) {
    router.push({name: 'home'});
  }
  document.getElementById('app').scrollTop = 0;
});

export default router;
